import { Ordenacao } from "app/api/classes/AtendimentoClienteApi"
import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { useAppSelector } from "app/redux/hooks"
import { Atendimentos } from "app/types/cliente/DadosAtendimento"
import { FiltrosAtendimento } from "app/types/cliente/FiltrosAtendimento"
import { IColuna } from "app/types/IColuna"
import { IOrcamento } from "app/types/IOrcamento"
import { Vendedor } from "app/types/Vendedor"
import { tratamentoErroPadrao } from "app/use-cases"
import * as R from 'ramda'
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { Atendimento } from "./Atendimento"
import { CadastrarAtendimentoContainer } from "./CadastrarAtendimento/CadastrarAtendimentoContainer"
import { obterPermissao } from "app/use-cases/obterPermissao"
import { substituirItemEmArray } from "substituirItemEmArray"
import { PesquisarClienteContainer } from "../pesquisa-cliente/PesquisarClienteContainer"
import { v4 as uuidv4 } from 'uuid';
import { Permissao } from "app/types/Permissao"

export type AtendimentoContainerProps = {
    onVoltar?: () => void;
    passos?: Dict<string, () => void>;
    onRemover: () => boolean
    onDefinirLeituraAtendimento?: (codigoAtendimento: number) => void
    foraOrcamento?: boolean
    regiaoRenderizada: string
    filtroAtendimento?: FiltrosAtendimento
}

export const AtendimentoContainer = (props: AtendimentoContainerProps) => {
    const nomeGrid = "PESQUISAR_ATENDIMENTOS_CLIENTES"
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)

    const [vendedores, setVendedores] = useState<Vendedor[]>([])
    const [vendedorLogado, setVendedorLogado] = useState<Vendedor>()
    const [permiteEngrenagemGrid, setPermiteEngrenagemGrid] = useState<boolean>(false)
    const [ordenacao, setOrdenacao] = useState<Ordenacao[]>([])
    const [atendimentos, setAtendimentos] = useState<Partial<PagedMessageResponse<Atendimentos>>>()
    const [colunas, setColunas] = useState<IColuna[]>([]);
    const [tamanhoFonte, setTamanhoFonte] = useState<number>(0);
    const [limparAtendimento, setLimparAtendimento] = useState(uuidv4())
    const [permissoes, setPermissoes] = useState<Permissao[]>([])
    const [filtroAtendimento, setFiltroAtendimento] = useState<FiltrosAtendimento>(props.filtroAtendimento ?? {
        CodigoCliente: orcamento?.Cliente?.Codigo,
        NomeCliente: orcamento?.Cliente?.Nome,
        NumeroPagina: 1,
        Ordenacao: "1",
        SomenteNaoLidos: false,
        TamanhoPagina: 20,
        permitidoAlterarCliente: false
    })

    const atualizarPermissoes = useCallback(async () => {
            const [incluirAtendimento] = await Promise.all([
                obterPermissao({ funcionalidade: "ORCAMENTO_ATENDIMENTO_CLIENTES", acao: "INCLUIR"}) // 489353
            ])
            if (!isMounted.current) return
            setPermissoes([
                { Acao: "INCLUIR_ATENDIMENTO_CLIENTES", Permitido: incluirAtendimento },
            ])
        }, [])

    const onDefinirLeituraAtendimento = (codigoAtendimento: number, lido: boolean) => {  // 444842
        setAtendimentos(prev => ({ ...prev, Entities: prev?.Entities?.map(a => a.Codigo == codigoAtendimento ? { ...a, Lido: lido } : a) }))

        try {
            globalMU.blockUI();
            microuniversoApi.AtendimentoCliente.DefinirLeitura(codigoAtendimento, lido) // 444842
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI();
        }


    }

    const onRenderizarAtendimento = () => renderizarComponentReact(<AtendimentoContainer {...props} />, props.regiaoRenderizada, true)

    const passosInterno = useRef<Dict<string, () => void>>( props.foraOrcamento ? new Dict() : new Dict(Object.assign({}, props.passos.map)))
    const isMounted = useRef<boolean>(true)
    const dadosGridCarregados = useRef(false)

    const obterDadosAtendimento = useCallback(async () => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.AtendimentoCliente.Pesquisar();
            if (!isMounted.current) return
            if (!("HasErrors" in resposta)) {
                !props.foraOrcamento && setFiltroAtendimento(prev => ({ ...prev, CodigoVendedor: resposta?.vendedor?.Codigo }))
                setVendedorLogado(resposta.vendedor)
                setOrdenacao(resposta.ordenacao)
            }
        } catch (e) {
            if (!isMounted.current) return
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI();
        }
    }, [])

    const permitidoAcaoFuncionalidade = async (siglaFuncionalidade: string, acao?: string) =>
        await obterPermissao({ funcionalidade: siglaFuncionalidade, acao })

    const atualizarPermiteEngrenagemGrid = useCallback(async () => {
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_ACESSO_ENGRENAGEM_GRID")
        if (!isMounted.current) return
        setPermiteEngrenagemGrid(permitido)
    }, [])

    const obterDadosIniciaisGrid = useCallback(async () => {
        dadosGridCarregados.current = true
        try {
            globalMU.blockUI();
            const dadosInicias = await microuniversoApi.Seguranca.obterDadosGrid("Orcamento", nomeGrid);
            if (!isMounted.current) return

            const ordemColunas = [
                "Lido", "Data", "DataProximoContato", "Contato", "Telefone", "Vendedor", "Cliente", "Atividade", "Motivo", "Texto"
            ]

            setColunas(
                R.pipe(
                    (colunas_: IColuna[]) => colunas_.map(c => ({
                        ...c,
                        Ordem: ordemColunas.findIndex(o => o == c.Nome)
                    }))
                )(dadosInicias.Colunas)
            )

            setTamanhoFonte(dadosInicias.TamanhoFonte);
        } catch (e) {
            dadosGridCarregados.current = false
            if (!isMounted.current) return
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, [])

    const onListarPorNomeVendedor = useCallback(async (nome: string) => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Vendedor.ListarPorNome(nome);
            if (!isMounted.current) return
            if (!("HasErrors" in resposta)) {
                setVendedores(resposta)
            }
        } catch (e) {
            if (!isMounted.current) return
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI();
        }
    }, [])

    const onPesquisarAtendimentos = useCallback(async (filtros: FiltrosAtendimento) => {
        
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.AtendimentoCliente.Listar(filtros);
            if (!isMounted.current) return
            if (!("HasErrors" in resposta)) {
                setAtendimentos(resposta);
                if (!dadosGridCarregados.current && resposta?.Entities?.length > 0) {
                    obterDadosIniciaisGrid()
                }
            }
        } catch (e) {
            if (!isMounted.current) return
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI();
        }
    }, [obterDadosIniciaisGrid])

    const novo = () => {
        renderizarComponentReact(
        <CadastrarAtendimentoContainer 
            {...props} 
            foraOrcamento={props.foraOrcamento} // 489353
            passos={passosInterno.current} 
            onVoltar={onRenderizarAtendimento} 
        />, props.regiaoRenderizada, true)
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onSelecionarTodasColunas = async (selecionar: boolean) => {
        const colunas_ = colunas.map(
            (c) => ({ ...c, Selecionada: selecionar } as IColuna)
        );
        setColunas(colunas_);

        try {
            await microuniversoApi.Seguranca.atualizarColunasGrid(colunas_, nomeGrid);
        } catch (e) {
            if (!isMounted.current) return
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    };

    const onAlterarFonte = async (tamanho: number) => {
        globalMU.blockUI();
        try {
            await microuniversoApi.Usuario.alterarFonte(nomeGrid, tamanho);
            globalMU.unblockUI();
        } catch (e) {
            tratamentoErroPadrao(e);
            globalMU.unblockUI();
        }
    };

    const onColunaSelecionada = async (nomeColuna: string, selecionada: boolean) => {
        let coluna = { ...colunas.find((c) => c.Nome == nomeColuna) };
        coluna.Selecionada = selecionada;

        const colunas_ = substituirItemEmArray(colunas, (coluna) => coluna.Nome == nomeColuna, coluna);

        setColunas(colunas_);

        try {
            await microuniversoApi.Seguranca.atualizarColunasGrid(colunas_, nomeGrid);
        } catch (e) {
            if (!isMounted.current) return
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    };

    const onPesquisarCliente = (dadosPesquisa: FiltrosAtendimento) => {
        renderizarComponentReact(
            <PesquisarClienteContainer
                regiaoRenderizada={props.regiaoRenderizada} passos={passosInterno.current} onVoltar={onRenderizarAtendimento} consultar
                foraOrcamento={true}
                onSelecionarClienteCallback={(cliente) => {
                    renderizarComponentReact(<AtendimentoContainer {...props}
                        filtroAtendimento={{ ...dadosPesquisa, CodigoCliente: cliente.Codigo, NomeCliente: cliente.Nome }} />, props.regiaoRenderizada, true)
                }}
            />, props.regiaoRenderizada, true)
    }

    const onLimpar = () => {
        setLimparAtendimento(uuidv4())
        setFiltroAtendimento({})
        setAtendimentos({})
    }

    useEffect(() => {
        props.foraOrcamento ? passosInterno.current.set("Pesquisar", () => onRenderizarAtendimento) : passosInterno.current.set("Atendimentos", () => onRenderizarAtendimento)
        Promise.all([
            atualizarPermissoes(), // 489353
            obterDadosAtendimento(),
            atualizarPermiteEngrenagemGrid(),
        ])
        return () => { isMounted.current = false }
    }, [])

    return (
<>
{ordenacao == undefined || ordenacao.length == 0
 ? <><span>Carregando... Aguarde!</span></>
 :
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={true}
                exibirBotaoVoltar={passosInterno.current.keysToList().length > 1}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
                onBotaoLimparClicado={onLimpar}
                id="AtendimentoBreadcrumb"
            />

            <Atendimento
                key={limparAtendimento}
                foraOrcamento={props.foraOrcamento} // 489353
                vendedorLogado={vendedorLogado}
                permiteEngrenagemGrid={permiteEngrenagemGrid}
                ordenacao={ordenacao}
                vendedores={vendedores}
                dadosAtendimento={atendimentos}
                informacaoAtendimento={filtroAtendimento}
                tamanhoFontePadrao={tamanhoFonte}
                possuiCliente={!orcamento.Cliente?.Codigo}
                colunas={colunas}
                onNovo={novo}
                permiteIncluirAtendimento={permissoes?.find((permissao) => permissao.Acao == "INCLUIR_ATENDIMENTO_CLIENTES")?.Permitido}
                onErrorValidacao={(erroFormulario) => globalMU.showErrorMessage(erroFormulario)}
                onPesquisar={onPesquisarAtendimentos}
                onPesquisarVendedor={onListarPorNomeVendedor}
                onColunaSelecionada={onColunaSelecionada}
                onAlterarFonte={onAlterarFonte}
                onSelecionarTodasColunas={onSelecionarTodasColunas}
                onLimparCliente={() => setFiltroAtendimento({ ...filtroAtendimento, NomeCliente: null, CodigoCliente: null })}
                onPesquisarCliente={onPesquisarCliente}
                onDefinirLeituraAtendimento={onDefinirLeituraAtendimento}

            />

        </>
}
</>
    )
}
